export default "__VITE_ASSET__xw2jS0VQ__"